<template>
  <div>
    <div class="rating">
      <ul>
        <li
          @click="initRating(client, rating)"
          v-for="rating in value"
          :key="rating.id"
          :style="{ backgroundColor: setColor(rating.value) }"
        >
          <span>{{ rating.value }}</span>
        </li>
      </ul>
      <button
        v-if="lessonplan_id"
        @click="
          initRating(client, { work: defaultWork, id: null, value: null })
        "
        class="btn btn-sm btn-success btn-icon"
      >
        <span class="ti-plus"></span>
        {{ "set_rating" | setText("Поставить оценку") }}
      </button>
    </div>
    <modal
      @closed="close"
      :name="`rating-${client.id}`"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      :scrollable="true"
      :height="'auto'"
    >
      <card>
        <selector
          v-model="rate.work"
          :title="`Задание`"
          :modal="`work`"
          :params="{ lessonplan_id: lessonplan_id }"
          :selectKey="`title`"
          :setLink="`business/timetables/${id}/works`"
        />

        <star-rating v-model="rate.value"></star-rating>
        <br />

        <button
          v-if="!rate.id"
          @click="createRating"
          class="btn btn-sm btn-success btn-icon mr-2"
        >
          {{ "set" | setText("Поставить") }}
        </button>
        <button
          v-if="rate.id"
          @click="updateRating"
          class="btn btn-sm btn-success btn-icon mr-2"
        >
          {{ "update" | setText("Обновить") }}
        </button>
        <button
          v-if="rate.id"
          @click="deleteRating"
          class="btn btn-sm btn-danger btn-icon mr-2"
        >
          {{ "delete" | setText("Удалить") }}
        </button>
        <button
          @click="$modal.hide(`rating-${client.id}`)"
          class="btn btn-sm btn-icon"
        >
          {{ "cancel" | setText("Отменить") }}
        </button>
      </card>
    </modal>
  </div>
</template>

<script>
import { setRating } from "@/_api/apiPupil";

export default {
  created() {},
  data: () => ({
    rate: {
      work: null,
      id: null,
      value: null,
    },
  }),
  methods: {
    setRating: setRating,
    close() {
      this.rate = {
        work: null,
        value: null,
        id: null,
      };
    },
    initRating(client, rate = { work: null, id: null, value: null }) {
      this.rate["id"] = rate.id;
      this.rate["work"] = rate.work;
      this.rate["value"] = rate.value;
      this.rate["client"] = this.client;
      this.rate["timetable_id"] = this.id;
      this.$modal.show(`rating-${client.id}`);
    },
    createRating() {
      this.setRating(this.rate, "post");
    },
    updateRating() {
      this.setRating(this.rate, "post");
    },
    deleteRating() {
      this.setRating(this.rate, "delete");
    },

    setColor(rate) {
      if (rate == 2) return "red";
      else if (rate == 3) return "orange";
      else if (rate == 4) return "blue";
      else if (rate == 5) return "green";
      else return "black";
    },
  },
  props: {
    value: {
      default: [],
    },
    id: {
      default: null,
    },
    lessonplan_id: {
      default: null,
    },
    client: {
      default: null,
    },
    defaultWork: {
      default: null,
    },
  },
  computed: {},
};
</script>

<style lang="scss">
div.rating {
  display: flex;
  align-items: center;

  & > ul {
    display: flex;
    align-items: center;
    margin-right: 10px;

    & > li {
      cursor: pointer;
      padding: 0;
      font-size: 20px;
      background: orange;
      display: flex;
      border-radius: 100%;
      margin-right: 10px;
      width: 35px;
      align-items: center;
      justify-content: center;
      height: 35px;

      & > span {
        color: #fff;
        display: block;
      }
    }
  }

  // & > button {
  // }
}
</style>
